import { PropsWithChildren } from 'react';
import { StyledOutletHeader } from './styled';

export function OutletHeader({
  children,
  backgroundColor
}: PropsWithChildren & { backgroundColor: string }): JSX.Element {
  return (
    <StyledOutletHeader backgroundColor={backgroundColor}>
      {children}
    </StyledOutletHeader>
  );
}
